/**
 * @generated SignedSource<<e8fa21b5c1bba9cf3f97a7e9169414d7>>
 * @relayHash 265b6fe4cbfa044f1ab40096cb493b63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf

import type { ConcreteRequest } from 'relay-runtime';
export type CreateWithRovoTemplateButtonTemplatesQuery$variables = {
  ids: ReadonlyArray<string>;
  spaceKey: string;
};
export type CreateWithRovoTemplateButtonTemplatesQuery$data = {
  readonly templateBodies: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly representation: string | null | undefined;
        readonly value: string | null | undefined;
      };
      readonly id: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type CreateWithRovoTemplateButtonTemplatesQuery = {
  response: CreateWithRovoTemplateButtonTemplatesQuery$data;
  variables: CreateWithRovoTemplateButtonTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ids"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "PaginatedTemplateBodyList",
    "kind": "LinkedField",
    "name": "templateBodies",
    "plural": false,
    "selections": [
      {
        "concreteType": "TemplateBody",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              },
              {
                "kind": "ScalarField",
                "name": "representation"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CreateWithRovoTemplateButtonTemplatesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateWithRovoTemplateButtonTemplatesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "265b6fe4cbfa044f1ab40096cb493b63",
    "id": "3f8a1ee157d04b6ef78b6a93ec05e9a843fbfaf25b1c9547bbf4a4e119edcbdf",
    "metadata": {},
    "name": "CreateWithRovoTemplateButtonTemplatesQuery",
    "operationKind": "query",
    "text": "query CreateWithRovoTemplateButtonTemplatesQuery($spaceKey:String!,$ids:[String!]!){templateBodies(spaceKey:$spaceKey,ids:$ids){nodes{id,body{value,representation}}}}"
  }
};
})();

(node as any).hash = "fb2c221974b3d859a17bc8058bcf89d8";

export default node;
